import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tpr-react-components"
    }}>{`TPR React Components`}</h1>
    <blockquote>
      <p parentName="blockquote">{`React Components is a design system for TPR`}</p>
    </blockquote>
    <p>{`React components are maintained following a multi-package approach where
components are packaged and published individually, but combined under this
single repository.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`See the individual package README for the React component you would like
to install.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Packages`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`@tpr/core`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`@tpr/forms`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`@tpr/icons`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`@tpr/layout`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`@tpr/theming`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`React Components packages are ready to use in a
`}<a parentName="p" {...{
        "href": "https://create-react-app.dev/"
      }}>{`Create React App`}</a>{` environment or together
with standard Rollup or webpack build configurations.`}</p>
    <p>{`Here is a simple example to get you started:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react';
import ReactDOM from 'react-dom';
import ThemeProvider from '@tpr/theming';
import { Button } from '@tpr/core';

const App = () => (
    /* Include a ThemeProvider wrapper at the root of your app */
    <ThemeProvider>
        <Button>Example React button</Button>
    </ThemeProvider>
);

ReactDOM.render(<App />, document.getElementById('root'));
`}</code></pre>
    <h2 {...{
      "id": "license"
    }}>{`LICENSE`}</h2>
    <p>{`MIT`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      